import FlightReceipt from "./flight-receipt";
import buildPromiseResolver from "../util/promise-resolver";
// @ts-ignore
import kvid from 'kvid';
const DefaultRequestOpts = {
    timeout: -1,
    rsvp: true,
};
export default class RemoteRequest {
    constructor(methodName, userArgs, requestOpts) {
        this.requestOpts = {};
        this._wasSent = false;
        if (typeof userArgs[userArgs.length - 1] === 'function') {
            this.nodejsCallback = userArgs.pop();
        }
        this.methodName = methodName;
        this.userArgs = userArgs;
        this.requestId = kvid(12);
        this._requestResolver = buildPromiseResolver();
        const opts = this.opts(Object.assign({}, DefaultRequestOpts, requestOpts));
        if (opts.outboundStack && opts.rsvp !== false) {
            this._outboundStackTrace = (new Error('NotAnError: force-generated stack for outbound rpc request')).stack;
        }
        this._initTimeout();
    }
    opts(requestOpts) {
        this.requestOpts = Object.assign(this.requestOpts || {}, requestOpts);
        return this.requestOpts;
    }
    isRsvp() {
        return !!this.requestOpts.rsvp;
    }
    decoratePayload(endpointBaseData) {
        const { requestId, methodName, userArgs } = this;
        const payload = Object.assign(endpointBaseData, {
            requestId, methodName, userArgs,
            rsvp: this.isRsvp(),
            transportMeta: {},
        });
        this._payload = payload;
        return payload;
    }
    dataForPayload() {
        const { requestId, methodName, userArgs } = this;
        return { requestId, methodName, userArgs, rsvp: this.isRsvp() };
    }
    flightReceipt() {
        const receipt = this._ensureFlightReceipt();
        const remotePromise = receipt._decoratedPromise();
        const cb = this.nodejsCallback;
        if (cb) {
            remotePromise
                .then((...results) => cb(null, ...results))
                .catch((err) => cb(err));
            return receipt;
        }
        else {
            return remotePromise;
        }
    }
    markAsSent() {
        this._wasSent = true;
        this._requestResolver.resolve();
    }
    responseReceived(error, ...result) {
        this._ensureFlightReceipt()._remoteResponseReceived(error, ...result);
    }
    abortRequest(error) {
        this._ensureFlightReceipt().abortRequest(error);
    }
    _ensureFlightReceipt() {
        if (!this._payload) {
            throw new Error('Cannot get receipt before request data initialized');
        }
        if (!this._receipt) {
            this._receipt = new FlightReceipt({
                payload: this._payload,
                nodejsCallback: this.nodejsCallback,
                promiseSent: this._requestResolver.promise,
                updateRequestOpts: (opts) => {
                    if (this._wasSent) {
                        throw new Error('RPC request was already sent');
                    }
                },
                outboundStackTrace: this._outboundStackTrace,
                responseErrorHandler: this.requestOpts.responseErrorHandler,
            });
            const timeout = this.requestOpts.timeout;
            if (typeof timeout === 'number' && timeout > 0) {
                this._receipt.updateTimeout(timeout);
            }
        }
        return this._receipt;
    }
    _initTimeout() {
        // todo: stash on this._timeout
    }
    _clearTimeout() {
        // todo: clearTimeout(this._timeout). // call if value changes or if force-resolved
    }
}
//# sourceMappingURL=remote-request.js.map